/**
 * Generated by orval 🍺
 * Do not edit manually.
 * TrainLoop Platform V2 API
 * Model evaluation workbench API
 * OpenAPI spec version: 0.0.0
 */

export type TeamInfoPermissionsItem =
  (typeof TeamInfoPermissionsItem)[keyof typeof TeamInfoPermissionsItem];

export const TeamInfoPermissionsItem = {
  audit_logread: "audit_log.read",
  billingread: "billing.read",
} as const;
